<template>
    <div class="mb-80px mb-md-100px mb-lg-120px">
        <v-row no-gutters>
            <v-col cols="12" md="5">
                <v-img :src="'/images/sub/product/product-' + num + '.jpg'" class="rounded-xl" />
            </v-col>
            <v-col>
                <v-sheet class="py-24px pl-md-80px">
                    <u-tit-wrap-default class="tit-wrap--sm">
                        <u-tit-default>{{ $t(name) }}</u-tit-default>
                    </u-tit-wrap-default>
                    <u-tit-default class="tit--xs mb-12px mb-md-14px mb-lg-16px">
                        <span class="primary px-4px py-4px px-lg-8px line-height-15 break-keep">{{ $t(tag) }}</span>
                    </u-tit-default>
                    <txt-primary class="grey--text text--darken-4">
                        <slot name="txt" />
                    </txt-primary>
                </v-sheet>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import UTitWrapDefault from "@/components/publish/styles/typography/u-tit-wrap-default.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";
import IconArrowSecondary from "@/components/publish/parents/icons/icon-arrow-secondary.vue";

export default {
    components: {
        UTitWrapDefault,
        UTitDefault,
        TxtPrimary,
        IconArrowSecondary,
    },
    props: {
        num: { type: String, default: "" },
        name: { type: String, default: "" },
        tag: { type: String, default: "" },
    },
};
</script>

<style lang="scss" scoped></style>
